import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useParams } from "react-router-dom";

import NavBar from "../components/global/NavBar";
import PartProgress from "../components/parts/PartProgress";
import axios from "../helpers/axios";
import { formatDate } from "../helpers/date";
import { formatDateTime } from "../helpers/date_time";
import '../styles/customStyles.scss';

const ShareOrderLink = () => {

  const site = process.env.REACT_APP_SITE;

  const { id } = useParams();
  //State
  const [isLoading, setLoading] = useState(false);
  const [is404, set404] = useState(false);
  const [backOrder, setBackOder] = useState(null);
  const [branch, setBranch] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const data = {
      email: formData.get('email')
    };
    const backorderId = backOrder.rfdcno;

    try {
      const response = await fetch('https://tracking.' + site +
        '/api/backorders/update-email/' +
        backorderId + '/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        setIsSubmitted(true);
        console.log('Update email');
        setTimeout(() => {
          setIsSubmitted(false);
        }, 2000);
      } else {
        console.error('Failed to update email');
      }
    } catch (error) {
      console.error('Error:', error);
    }

  };

  //Functions
  const fetchDocument = (id) => {
    setLoading(true);

    axios
      .get(`api/backorders/${id}/`)
      .then(async ({ status, data }) => {
        if (status === 200) {
          setBackOder(data);
          axios
            .get(`/api/branch_id/?id=${data.stno}`)
            .then(async ({ status, data}) => {
              setBranch(data[0]);
            })
        } else {
          setBackOder(null);
          set404(true);
        }
      })
      .catch(() => {
        setBackOder(null);
        setBranch(null);
        set404(true);
      })
      .then(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDocument(id);
  }, [id]);

  const displayQty = (part) => {
    let actualQty;

    switch (part.status) {
      case 10:
      case 20:
      case 31:
      case 40:
        actualQty = part.qty4;
        break;
      case 30:
        if (part.fcabn6[0] === "$") {
          actualQty = part.tfrqty;
        } else {
          actualQty = part.qty4;
        }
        break;
      case 50:
      case 60:
      case 70:
      case 80:
        actualQty = part.spqty;
        break;
      default:
        actualQty = part.qty4;
        break;
    }

    return `${actualQty}/${part.qty4}`;
  };

  return (
    <div>
      <NavBar />
      <br />
      <br />
      <div className="container">
        <nav className="level">
          <div className="level-left">
            <div className="level-item">
              <p className="is-size-4">
                <b>Seguimiento de Envíos</b>
              </p>
              <form className="form-container" onSubmit={handleSubmit}>
                <div class="columns is-centered">
                  <div class="column is-narrow">
                    <div class="field">
                      <label class="label is-size-8">Correo</label>
                      <div class="control">
                        <input class="input is-size-7 custom-width"
                          type="email"
                          name="email"
                          placeholder="Ingrese su correo electrónico"></input>
                      </div>
                    </div>
                  </div>
                <div className="column is-narrow">
                  <div className="field">
                    <label className="label is-size-8">&nbsp;</label>
                    <div className="control">
                      <button
                        className={`button is-primary is-size-7 ${isSubmitted ? 'is-success' : ''}`}
                      >{isSubmitted ? 'Listo!' : 'Guardar'}</button>
                    </div>
                  </div>
                </div>
                </div>
              </form>
            </div>
          </div>

          <div className="level-right">
            <p className="level-item">
              <FontAwesomeIcon icon={["fas", "phone-alt"]} />
              &nbsp;
              <b>800 561 4944</b>
            </p>
            <p className="level-item">
              <FontAwesomeIcon icon={["fas", "envelope"]} />
              &nbsp;
              <b>atencionclientes@{site}</b>
            </p>
          </div>
        </nav>

        <div
          style={{
            padding: "2rem",
            backgroundColor: "#f5f5f5",
            borderRadius: "10px",
          }}
        >
          {isLoading ? (
            <section className="hero">
              <div className="hero-body">
                <div className="container has-text-centered">
                  <h1 className="title">Cargando...</h1>
                </div>
              </div>
            </section>
          ) : is404 ? (
            <section className="hero">
              <div className="hero-body">
                <div className="container has-text-centered">
                  <h1 className="title">Error 404</h1>
                  <h2 className="subtitle">
                    El documento buscado no se pudo ser localizado
                  </h2>
                </div>
              </div>
            </section>
          ) : backOrder !== null ? (
            <React.Fragment>
              <div className="card" style={{ marginBottom: "1rem" }}>
                <div className="level" style={{ lineHeight: "70px" }}>
                  <div className="level-item has-text-centered" onClick={() => window.history.back()}>
                      <div className="field has-addons mb-0 mr-3">
                        <p className="control">
                            <button
                              style={{top: 15, left: 17}}
                              className="button is-light"
                            >
                              <FontAwesomeIcon icon={["fas", "chevron-left"]} />
                            </button>
                        </p>
                      </div>
                  </div>
                  <div className="level-item has-text-centered">
                    <b>Documento:</b>
                    &nbsp;
                    {backOrder.rfdcno}
                  </div>
                  <div className="level-item has-text-centered">
                    <b>Código de cliente:</b>
                    &nbsp;
                    {backOrder.cuno}
                  </div>
                  <div className="level-item has-text-centered">
                    <b>Destino:</b>
                    {branch ? (
                      <div>
                        &nbsp; {branch.name}
                      </div>
                    ) : (
                      <div>
                        &nbsp; {backOrder.stno}
                      </div>
                    )}

                  </div>
                </div>
              </div>
              <br />
              <div className="card">
                <table className="table is-large paddin-top-bottom-15 is-striped is-fullwidth has-text-centered">
                  <thead>
                    <tr>
                      <th colSpan="2">N. Parte</th>
                      <th>Descripción</th>
                      <th>Cantidad</th>
                      <th>Estatus</th>
                      <th>Fecha Estimada de Llegada</th>
                      <th>Fecha LLegada</th>
                      <th>NOTAS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {backOrder.parts.map((part, ix) => (
                      <tr key={ix}>
                        <td className="has-text-right">{part.pano20}</td>
                        <td></td>
                        <td >{part.ds18}</td>
                        <td>{displayQty(part)}</td>
                        <td
                          style={{
                            borderLeftColor: "#dadada",
                            borderLeftWidth: "2px",
                          }}
                        >
                          <PartProgress part={part} />
                        </td>
                        <td>
                          {part.status < 50
                            ? formatDate(
                                part.override_time || part.estimated_time
                              )
                            : "-"}
                        </td>
                        <td>
                          {part.status === 50
                            ? formatDateTime(
                                part.invoice_date
                              )
                            : "-"}
                        </td>
                        <td>{part.notes}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </React.Fragment>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ShareOrderLink;
